import { Component, Input } from '@angular/core';
import { ClientReferralTask } from '../../../core/models/client-referral-task.model';
import { ClientReferralTaskStatus } from '../../../core/enums/client-referral-task-status.enum';
import { DecimalPipe, DatePipe } from '@angular/common';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ClientReferralTaskClosedComponent } from '../client-referral-task-closed/client-referral-task-closed.component';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';
import { PatientAlternateNamesComponent } from '../../../shared/components/patient-alternate-names/patient-alternate-names.component';

@Component({
    selector: 'app-client-referral-task-header',
    templateUrl: './client-referral-task-header.component.html',
    imports: [UserPresenceComponent,
              TaskEstimatedValueComponent,
              ClientReferralTaskClosedComponent,
              DecimalPipe,
              DatePipe,
              TaskStatusPipe,
              PatientAlternateNamesComponent]
})
export class ClientReferralTaskHeaderComponent {
  @Input() task: ClientReferralTask;
  @Input() displayUserPresence = true;

  referralTaskStatuses = ClientReferralTaskStatus;

  constructor() {}
}
